module.exports = __webpack_public_path__ + "static/media/oneThousuand.517dd737.ogg";